import { VerticalNavItemsType } from 'src/@core/layouts/types'

import { useTranslation } from 'react-i18next'

const Navigation = (): VerticalNavItemsType => {
  const { t } = useTranslation()

  return [
    {
      title: `${t('layout.meetings')} (disabled)`,
      path: '/meetings',
    },
    {
      title: `${t('layout.patients')} (disabled)`,
      path: '/patients',
    },
    {
      title: `${t('layout.payments')} (disabled)`,
      path: '/payments',
    },
    {
      title: `${t('layout.bookings')} (disabled)`,
      path: '/bookings',
    },
    {
      title: `${t('layout.subscriptions')}`,
      path: '/subscriptions',
    },
    {
      title: `${t('layout.export-users-review')}`,
      path: '/export-users-review',
    },
    {
      title: `${t('layout.pending-caregivers')}`,
      path: '/pending-caregivers',
    },
  ]
}

export default Navigation
